const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: [],
    listaImagens: [],
    linkCatalogoComPreco: null,
    linkCatalogoSemPreco: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PRODUTO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'PRODUTO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'PRODUTO_LISTADO':
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id_produto,
                    valor: `${item.codigo} - ${item.descricao}`,
                    descricao: item.descricao,
                    codigo: item.codigo
                }))
            };

        case 'PRODUTO_IMAGENS_LISTADO':
            return {
                ...state, 
                listaImagens: action.payload.data
            };

        case 'PRODUTO_LINK_COM_PRECO_GERADO':            
            return {
                ...state, 
                linkCatalogoComPreco: action.payload
            };

        case 'PRODUTO_LINK_SEM_PRECO_GERADO':            
            return {
                ...state, 
                linkCatalogoSemPreco: action.payload
            };

        default:
            return state;
    }
}
